import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../../utils/loading'
import ErrorWidget from '../../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { getImportUserRolePage } from '../../../../redux/actions/manageAccess'
import ImportUserRoleWidget from '../../../../widgets/manageUserRole/ImportUserRoleWidget'

export default function ImportUserRole() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()
  const [projectCode, setProjectCode] = useState()

  const mockSchema = {
    header: 'นำเข้าข้อมูลรายชื่อพี่เลี้ยง',
    subHeader: '',
    form: {
      title: 'นำเข้าข้อมูล',
      attachFileImport: {
        name: 'attachFileImport',
        label: 'แนบไฟล์รายชื่อพี่เลี้ยง',
        value: [],
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            hide: false,
            errorMessage: 'กรุณาแนบไฟล์รายชื่อพี่เลี้ยง',
          },
        ],
      },
      templateFilePath: 'system-doc/e-filling/ภ.ง.ด.1.xlsx',
    },
  }

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getImportUserRolePage()
      if (response) {
        setSchema(response)
      }
    } catch (e) {
      // console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProjectReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal isSubProjectReport>
        <ContentHeader header={schema.header} subHeader={schema.subHeader} />

        {/* <ManageUserRoleWidget schema={schema.form} /> */}
        <ImportUserRoleWidget schema={schema.form} />
      </SidebarProposal>
    </>
  )
}
